export default "/_next/static/6501723164dbc2e229698d80fa591e65.png";